import * as _ from 'lodash'
import {isNullOrWhiteSpace} from "./app";
import {Const} from "./const";
export const formatFPN = (value, type = 2) => {
    if (!Number.isNaN(Number.parseFloat(value))) {
        return Number.parseFloat(value).toLocaleString("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: type
        })
    } else {
        return "";
    }
};
export const isNumber = (num) => {
    return !isNaN(num);
}

export function isNullOrEmpty(value){
    return value === null || value === undefined || value === "";
}
export function getListYear(gap = 10){
    const currentYear = new Date().getFullYear();
    return _.range(currentYear,currentYear-gap-1,-1);
}
export function getListYearReactSelect(gap = 10){
    return getListYear(gap).map(year => ({value: year,label: year}));
}
export function getListPreviousYearReactSelect(gap = 10){
    return getListYear(gap).filter(year => year < new Date().getFullYear()).map(year => ({value: year,label: year}));
}
export function parseNumberSeparator(value) {
    if(typeof value === "number") return value;
    if (value === undefined || value === null) return null;
    const normalized = value.replace(/,/g, "");
    const num = Number(normalized);
    if (isNaN(num)) {
        return null;
    }
    return num;
}
export const validateTextInputMaximum = (value,limit=255) => {
    if(!isNullOrWhiteSpace(value)){
        if(value.length > limit){
            return false;
        }
    }
    return true;
}
export const toNumber = (value) => {
    if(isNullOrWhiteSpace(value)) return NaN;
    const normalized = Number(parseNumberSeparator(value));
    if(isNaN(normalized)){
        return NaN;
    }
    return normalized;
}
export const validateNumberMaximum = (value,max = Const.NUMBER_MAX_LIMIT) => {
    if(isNullOrWhiteSpace(value)) return true;
    if(value > max){
        return false;
    }
    return true;
}
export const validateRequire = (value) => {
    return value?.toString().length > 0;
}
export const NumberFormatAllowUtils = {
    within24Hours : (values) => {
        const {floatValue} = values;
        return floatValue === undefined || ( floatValue <= 24 && floatValue >= 0);
    },
    widthinAYear: (values) => {
        const {floatValue} = values;
        return floatValue === undefined || (floatValue <= 365 && floatValue >= 0);
    },
    greaterOrEqualZero: (values) => {
        const {floatValue} = values;
        return floatValue === undefined || (floatValue >= 0 && floatValue <= Const.NUMBER_MAX_LIMIT);
    },
}
export const isAnyNullOrUndefined = (...arr) => {
    return arr.some(v => v === null || v === undefined);
}
export const accumulate = (list,initial = null) => {
    if(Array.isArray(list)){
        return list.reduce((acc,r) => r || acc ? acc + r : null,initial);
    }
}
export async function convertSvgStringToPngBytes(svgString, width, height, scale = 2) {
    const blob = new Blob([svgString], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(blob);
    const img = new Image();
    img.src = url;
    await img.decode();

    const canvas = document.createElement('canvas');
    canvas.width = width * scale;
    canvas.height = height * scale;
    const ctx = canvas.getContext('2d');
    ctx.scale(scale, scale);

    ctx.drawImage(img, 0, 0, width, height);

    return new Promise((resolve) => {
        canvas.toBlob((blob) => {
            const reader = new FileReader();
            reader.onload = () => resolve(new Uint8Array(reader.result));
            reader.readAsArrayBuffer(blob);
        }, 'image/png');
    });
}
export const convertNumberToRoman = (num) => {
    if (num <= 0 || num >= 4000) throw new RangeError("Value must be between 1 and 3999");

    const map = [
        { value: 1000, symbol: "M" },
        { value: 900,  symbol: "CM" },
        { value: 500,  symbol: "D" },
        { value: 400,  symbol: "CD" },
        { value: 100,  symbol: "C" },
        { value: 90,   symbol: "XC" },
        { value: 50,   symbol: "L" },
        { value: 40,   symbol: "XL" },
        { value: 10,   symbol: "X" },
        { value: 9,    symbol: "IX" },
        { value: 5,    symbol: "V" },
        { value: 4,    symbol: "IV" },
        { value: 1,    symbol: "I" },
    ];

    let result = "";
    for (const { value, symbol } of map) {
        while (num >= value) {
            result += symbol;
            num -= value;
        }
    }
    return result;
}